import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { GetOrderActionRules, OmniChannelService, OperationFlagService } from './components';
import { SM } from './serviceManagment.classes';

export const ServiceManagment: FC<any> = () => {
    const { t } = useTranslation();
    return (
        <SCUIContent className={SM.page}>
            <Typography variant="h5" fontWeight={700} className={SM.title} sx={{ mb: 3 }}>
                {t('dashboard.serviceManagement')}
            </Typography>
            <Stack spacing={2} sx={{ maxWidth: 560 }} className={SM.cardsStack}>
                <div className={SM.omniChannelSection}>
                    <OmniChannelService />
                </div>
                <div className={SM.operationFlagSection}>
                    <OperationFlagService />
                </div>
                <div className={SM.orderActionRulesSection}>
                    <GetOrderActionRules />
                </div>
            </Stack>
        </SCUIContent>
    );
};
